import { MotiView } from "moti";
import { useCallback } from "react";
import { Circle, Paragraph, StyledMultiActionButton, Text } from "@medbillai/ui";
import { spring } from "../../../lib/animations/motiConstants";
import { useSignUpOnboardingStore } from "../../../lib/sign-up-onboarding/signUpOnboardingStore";
export const GetStartedActionButton = ({
  id,
  icon,
  label,
  stageId,
  stagerDelay
}: {
  id: string;
  icon: string;
  label: string;
  stageId: string;
  stagerDelay: number;
}) => {
  // This does seem weird but it improves the performance of the mobile app
  // substantially over passing the entire answers object to the component and
  // determining the selected state in the component.
  const toggleOption = useSignUpOnboardingStore(s => s.toggleOption);
  const isSelected = useSignUpOnboardingStore(useCallback(s => s.answers[stageId]?.includes(id) ?? false, [stageId, id]));
  return <MotiView key={id} from={{
    opacity: 0,
    translateY: 8,
    scale: 0.95
  }} animate={{
    opacity: 1,
    translateY: 0,
    scale: 1
  }} exit={{
    opacity: 0,
    scale: 0.95
  }} transition={{
    ...spring,
    delay: stagerDelay
  }} exitTransition={spring} data-sentry-element="MotiView" data-sentry-component="GetStartedActionButton" data-sentry-source-file="GetStartedActionButton.tsx">
      <StyledMultiActionButton key={id} onPress={() => toggleOption(id)} selected={isSelected} data-sentry-element="StyledMultiActionButton" data-sentry-source-file="GetStartedActionButton.tsx">
        <Circle size={40} borderWidth={1} borderColor="$strokeSecondary" overflow="hidden" alignItems="center" justifyContent="center" mr="$sp2" data-sentry-element="Circle" data-sentry-source-file="GetStartedActionButton.tsx">
          <Text data-sentry-element="Text" data-sentry-source-file="GetStartedActionButton.tsx">{icon}</Text>
        </Circle>
        <Paragraph theme={isSelected ? "granted" : "alt1"} pr="$2.5" data-sentry-element="Paragraph" data-sentry-source-file="GetStartedActionButton.tsx">
          {label}
        </Paragraph>
      </StyledMultiActionButton>
    </MotiView>;
};